import axiosInstance from "../Core/RestHelper";

interface MFAVerificationRequest {
  email: string;
  token: string;
  user_type?: string;
  code: string;
  provider_type?:string;
}

interface MFAVerificationResponse {
  access_token: string;
  token_type: string;
}

export class MFAService {
  private static readonly MFA_VERIFY_URL = 'https://galaxy.qixdeploy.com/api/admin/mfa/verify';

  static async verifyMFA(
    email: string,
    token: string,
    code: string,
    user_type?:string,
    provider_type?:string,
  ): Promise<MFAVerificationResponse> {
    const requestBody: MFAVerificationRequest = {
      email,
      token,
      user_type,
      code,
      provider_type
    };

    const response = await axiosInstance.post('admin/mfa/verify', requestBody)
    console.log("RESPONSE",response)

    // const response = await fetch(this.MFA_VERIFY_URL, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify(requestBody)
    // });

    if (response.status!==200) {
      const errorData = await response.data.catch(() => ({}));
      throw new Error(errorData.detail || errorData.message || 'MFA verification failed');
    }

    const data = await response.data;
    console.log("data",data)
    if (!data.access_token) {
      throw new Error('No access token received from MFA verification');
    }

    return data as MFAVerificationResponse;
  }
}